"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const ComparePopupContainer_1 = tslib_1.__importDefault(require("./ComparePopupContainer"));
const BasketPopupContainer_1 = tslib_1.__importDefault(require("./BasketPopupContainer"));
const EssentialsContainer = ({ basketPopUp }) => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(BasketPopupContainer_1.default, { recommendations: basketPopUp }), (0, jsx_runtime_1.jsx)(ComparePopupContainer_1.default, {})] }));
exports.default = EssentialsContainer;
